import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'

const DirectSelectRouteModeCommon = {
  onVertex(state, e) {
    this.startDragging(state, e)
    const about = e.featureTarget.properties
    const selectedIndex = state.selectedCoordPaths.indexOf(about.coord_path)

    // Helper to parse path. Returns { prefix: string, index: number } or null
    const parsePath = path => {
      if (!path) return null
      const parts = path.split('.')
      const index = parseInt(parts[parts.length - 1], 10)
      if (isNaN(index)) return null
      const prefix = parts.slice(0, parts.length - 1).join('.')
      return { prefix, index }
    }

    if (e.originalEvent.shiftKey) {
      const lastSelectedPath = state.selectedCoordPaths[state.selectedCoordPaths.length - 1]
      const last = parsePath(lastSelectedPath)
      const current = parsePath(about.coord_path)

      if (selectedIndex === -1) {
        if (last && current && last.prefix === current.prefix) {
          const start = Math.min(last.index, current.index)
          const end = Math.max(last.index, current.index)
          const prefix = last.prefix ? `${last.prefix}.` : ''

          for (let i = start; i <= end; i++) {
            const path = `${prefix}${i}`
            if (!state.selectedCoordPaths.includes(path)) {
              state.selectedCoordPaths.push(path)
            }
          }
        } else {
          state.selectedCoordPaths.push(about.coord_path)
        }
      } else {
        state.selectedCoordPaths.splice(selectedIndex, 1)
      }
    } else {
      // If not Shift, and not already selected, select only this one.
      if (selectedIndex === -1) {
        state.selectedCoordPaths = [about.coord_path]
      }
    }
    const selectedCoordinates = this.pathsToCoordinates(state.featureId, state.selectedCoordPaths)
    this.setSelectedCoordinates(selectedCoordinates)
  },

  onClick(state, e) {
    if (noTarget(e)) return this.clickNoTarget(state, e)
    if (isActiveFeature(e)) return this.clickActiveFeature(state, e)
    if (isInactiveFeature(e)) return this.clickInactive(state, e)

    if (isVertex(e)) {
      if (this.clickedVertex && this.clickedVertex === e.featureTarget.properties.coord_path) {
        this.onTrash(state)
        this.clickedVertex = undefined
      } else {
        this.clickedVertex = e.featureTarget.properties.coord_path
        setTimeout(() => {
          this.clickedVertex = undefined
        }, 300)
      }
    }
    this.stopDragging(state)
  },
}

export default DirectSelectRouteModeCommon
